module.exports = __webpack_public_path__ + "img/noProductImage.789eed23.svg";